import WhiteRight from '../../../media/felsv/white_right-arrow_icon.svg'
import {useHistory} from 'react-router'
import {ProductosF} from '../../../interfaces/facturacion.interface'
import {State} from '../../../reducers'
import {useDispatch, useSelector} from 'react-redux'
import {facturacionModalsOpenQuitarTodo} from '../../../actions/facturacion/facturacionProductos.actions'
import {generalOpenModalError} from '../../../actions/general.actions'
import {bindActionCreators} from 'redux'
import {actionFacturacionEmision} from '../../../actions/action-creators'

const mensajeError = 'No existen productos para eliminar'

const Footer = () => {
  const history = useHistory()
  const {activeDoc} = useSelector((state: State) => state.documentos)
  const arrayProductos: Array<ProductosF> = useSelector(
    (state: State) => state.facturacion.arrayProductos
  )
  const dispatch = useDispatch()
  const {facturacionClicGenerarFactura, facturacionClicGenerarNotaCredito} = bindActionCreators(actionFacturacionEmision, dispatch)

  const generarFactura = async () => {
    switch (activeDoc.idDoc) {
      case "05":
        if (await facturacionClicGenerarNotaCredito()) history.push('/otros-documentos/emitir/resumen')
        break;

      default:
        if (await facturacionClicGenerarFactura()) history.push('/otros-documentos/emitir/resumen')
        break;
    }
  }

  const openModalQuitarTodo = () => {
    if (arrayProductos.length === 0) return dispatch(generalOpenModalError(mensajeError))
    dispatch(facturacionModalsOpenQuitarTodo())
  }

  return (
    <>
      <div className='form-separator'></div>
      <div className='w-layout-hflex button-actions'>
        <button className='m button transparent botton-footer' onClick={openModalQuitarTodo}>
          <div>Quitar todo</div>
        </button>
        <div style={{width: '65%'}}></div>
        <button className='m button botton-footer' onClick={generarFactura}>
          <div>Siguiente</div>
          <img src={WhiteRight} loading='lazy' alt='Generar' />
        </button>
      </div>
    </>
  )
}

export default Footer
